export default "__VITE_ASSET__df325e2b__"